const divergenceFieldLabels: { [key: string]: string } = {
	name: 'Nome',
	position: 'Cargo',
	cpf: 'CPF',
	admissionDate: 'Data de admissão',
	dismissalDate: 'Data de desligamento',
	birthDate: 'Data de nascimento',
	cbo: 'CBO',
	workplace: 'Local de trabalho',
	registration: 'Matrícula',
	situation: 'Situação'
};

export function getDivergenceFieldLabel(field: string) {
	return divergenceFieldLabels[field] || field;
}

export type IgnoredDivergence = {
	id: number;
	cnpj: string;
	field: string;
	sggValue: string;
	esocialValue: string;
	username: string;
	accountName: string;
	createdAt: string;
};